import { Link, useLocation } from "@tanstack/react-router";

import { Button } from "./ui/button";

/**
 * Router-wide not-found surface. Rendered wherever a route throws `notFound()`
 * — an unknown path, or a segment that cannot name the thing the route wants —
 * in place of that route's content, under the global bar. Without it TanStack
 * falls back to unstyled default text.
 */
export function RouteNotFoundSurface() {
  const pathname = useLocation({ select: (location) => location.pathname });

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <div className="flex max-w-md flex-col items-center gap-3 rounded-lg border border-border bg-card p-8 text-center shadow-xs">
        <h1 className="text-lg font-semibold text-foreground">Page not found</h1>
        <p className="text-sm text-muted-foreground">
          Nothing lives at{" "}
          <code className="rounded-sm bg-muted px-1 py-0.5 font-mono text-[0.85em] text-foreground">
            {pathname}
          </code>
          . The address may be mistyped, or the page may have moved.
        </p>
        <Button render={<Link to="/" />} variant="outline">
          Back to threads
        </Button>
      </div>
    </div>
  );
}
